// extracted by mini-css-extract-plugin
export var container = "_5i-1";
export var editor = "_5i-2";
export var resizable = "_5i-3";
export var wrapper = "_5i-0";